<!-- <mat-drawer-container class="example-container" autosize>
  <mat-drawer mode="push" #drawer [opened]="showDrawer" [disableClose]="false" class="example-sidenav" mode="side">
    <div class="close-menu">
      <img src="../assets/icons/menu-white.svg" class="menu-icon" width="28" alt="111" (click)="drawer.toggle()" />
    </div>
    <div class="profile">
      <div>
        <img *ngIf="userAvatar" class="profile-img" [src]="userAvatar" />
        <img *ngIf="!userAvatar" class="profile-img" src="../assets/icons/default-user-icon-profile.png" />
      </div>

      <mat-menu #menu="matMenu"> </mat-menu>
      <mat-accordion>
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title class="profile-name">
              {{ userName }}
            </mat-panel-title>
          </mat-expansion-panel-header>
          <button class="prolile-menu" mat-menu-item [routerLink]="['/minha-conta']">
            <span>Alterar meus dados</span>
          </button>
          <button class="prolile-menu" mat-menu-item [routerLink]="['/changePassword']">
            <span>Alterar senha</span>
          </button>
          <button class="prolile-menu" mat-menu-item (click)="logout()" style="color: #cd0505">
            sair &nbsp;<img class="exit-icon" src="../assets/icons/exit.svg" />
          </button>
        </mat-expansion-panel>
      </mat-accordion>

      <div></div>
    </div>
    <mat-divider></mat-divider>
    <div class="menu-list" id="menu">
      <div class="menu-item" id="111" [routerLink]="['/dashboard']" [routerLinkActive]="['menu-item-active']">
        <img src="../assets/icons/home.svg" color="#000" class="menu-icon" />
        <div class="menu-title">
          <p>home</p>
        </div>
      </div>

      <div
        *ngFor="let route of routesAllowed"
        class="menu-item"
        [routerLink]="[route]"
        [routerLinkActive]="['menu-item-active']"
      >
        <img [src]="'../assets/icons/' + routers[route]" class="menu-icon" />
        <p>{{ route }}</p>
      </div>
    </div>
  </mat-drawer>
  <app-toolbar *ngIf="drawer" [drawerRefer]="drawer"></app-toolbar>
  <div class="container">
  </div>
</mat-drawer-container>
-->
<router-outlet> </router-outlet>
